import { render, staticRenderFns } from "./TaskConfigurationMessages.vue?vue&type=template&id=24887b17&"
import script from "./TaskConfigurationMessages.vue?vue&type=script&lang=ts&"
export * from "./TaskConfigurationMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports